module.exports = __webpack_public_path__ + "img/player_run_002.0cc18ba6.png";